export default "__VITE_ASSET__DOnJgGwk__"